var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 90,
    viewBox: "0 0 150 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.746 28.7632L91.6794 10.313C89.5091 8.63097 86.7562 7.87344 84.0231 8.20612L53.0991 12.0031C50.3646 12.3403 47.8745 13.7417 46.1744 15.9003L34.3304 35.6639L21.4844 37.2412C17.7985 37.6937 14.4422 39.5835 12.1536 42.4949C9.86496 45.4063 8.83138 49.1011 9.27999 52.7667L11.2875 69.1166L28.6382 66.9862M70.842 19.2401L72.5726 33.3347L117.414 27.8288C121.529 27.3235 125.675 28.4646 128.941 31.0011C132.206 33.5376 134.322 37.2617 134.825 41.3541L136.352 53.7937L123.376 55.387M50.1906 64.3455L101.62 58.0307M50.1421 63.9505C50.869 69.8708 46.6322 75.2628 40.679 75.9937C34.7257 76.7247 29.3103 72.5179 28.5834 66.5976C27.8565 60.6773 32.0933 55.2854 38.0465 54.5544C43.9998 53.8235 49.4152 58.0302 50.1421 63.9505ZM123.123 54.9896C123.85 60.9099 119.613 66.3018 113.66 67.0328C107.706 67.7638 102.291 63.557 101.564 57.6367C100.837 51.7164 105.074 46.3245 111.027 45.5935C116.981 44.8625 122.396 49.0693 123.123 54.9896Z",
    stroke: "white",
    strokeWidth: 11,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 48,
    transform: "translate(47.9233 14.6536) rotate(-7)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 30,
    transform: "translate(39.9829 15.6287) rotate(-7)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    transform: "translate(19.3479 36.2974) rotate(-7)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 23,
    transform: "translate(12.2607 44.2202) rotate(-7)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 33,
    transform: "translate(97.6196 33.7395) rotate(-7)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 33,
    transform: "translate(23.1787 42.8796) rotate(-7)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.746 28.7632L91.6794 10.313C89.5091 8.63097 86.7562 7.87344 84.0231 8.20612L53.0991 12.0031C50.3646 12.3403 47.8745 13.7417 46.1744 15.9003L34.3304 35.6639L21.4844 37.2412C17.7985 37.6937 14.4422 39.5835 12.1536 42.4949C9.86496 45.4063 8.83138 49.1011 9.27999 52.7667L11.2875 69.1166L28.6382 66.9862M70.842 19.2401L72.5726 33.3347L117.414 27.8288C121.529 27.3235 125.675 28.4646 128.941 31.0011C132.206 33.5376 134.322 37.2617 134.825 41.3541L136.352 53.7937L123.376 55.387M50.1906 64.3455L101.62 58.0307M50.1421 63.9505C50.869 69.8708 46.6322 75.2628 40.679 75.9937C34.7257 76.7247 29.3103 72.5179 28.5834 66.5976C27.8565 60.6773 32.0933 55.2854 38.0465 54.5544C43.9998 53.8235 49.4152 58.0302 50.1421 63.9505ZM123.123 54.9896C123.85 60.9099 119.613 66.3018 113.66 67.0328C107.706 67.7638 102.291 63.557 101.564 57.6367C100.837 51.7164 105.074 46.3245 111.027 45.5935C116.981 44.8625 122.396 49.0693 123.123 54.9896Z",
    stroke: "#33058D",
    strokeWidth: 4.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_137",
    x: 0.677246,
    y: 0.629395,
    width: 148.804,
    height: 88.9473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_137",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/car.0e231075dd38eb0db97c02575f9b2993.svg";